import $ from 'jquery';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '@gasbuddy/react';
import { Dropdown } from '@gasbuddy/react-components';
import bpUtils from '../../../lib/bputils';
import WatchStation from '../watch-station';
import styles from './styles.css';
import StationPropType from '../../utils/prop-types/station';
import { setStation, setLoading } from '../../actions';
import { StationListResponseType } from '../../../lib/constants/enums';
import Notification from '../notification';

const { api, logError } = require('../../../lib/bputils').default;

class StationSelector extends React.Component {
  static propTypes = {
    station: StationPropType,
    dispatchSetLoading: PropTypes.func,
    dispatchSetStation: PropTypes.func,
    onReady: PropTypes.func,
    onChange: PropTypes.func,
    className: PropTypes.string,
    doNotStoreChanges: PropTypes.bool,
    watchStations: PropTypes.bool,
  };

  static defaultProps = {
    station: null,
    dispatchSetLoading: null,
    dispatchSetStation: null,
    onReady: () => {},
    onChange: () => {},
    className: '',
    doNotStoreChanges: false,
    watchStations: true,
  };

  state = {
    stations: [],
    stationId: this.props.station?.id || 0,
    stationOptions: [],
  };

  componentDidMount = () => {
    this.getStations();
    this.attachHackToFocusSearchTextBox();
  }

  componentDidUpdate = (prevProps) => {
    const { station } = this.props;
    if (prevProps.station?.id !== station?.id) {
      const stations = _.cloneDeep(this.state.stations);
      const selectedStationIndex = stations.findIndex(s => s.id === station?.id);

      if (selectedStationIndex >= 0 && !_.isEqual(station, prevProps.station)) {
        stations[selectedStationIndex].address = _.cloneDeep(station.address);
        stations[selectedStationIndex].retailer_name = station.retailer_name;
        stations[selectedStationIndex].retailer_reference = station.retailer_reference;
        this.setShowableItems(stations);
      }
      this.setState(() => ({
        stationId: station?.id || 0,
      }));
    }
  }

  attachHackToFocusSearchTextBox = () => {
    $('button[class*=dropdown__toggle_]').on('click', () => {
      window.setTimeout(() => $('input[class*=dropdown__searchInput]').focus(), 200);
    });
  }

  getStations = (callback) => {
    const self = this;
    const { onReady } = this.props;
    api.get({
      path: `/stations?response_type=${StationListResponseType.stations_with_address}`,
      requestId: 'getAllStations',
    }).then((res) => {
      const stations = res;
      if (callback && typeof callback === 'function') {
        callback(stations);
      }
      self.setState(() => ({
        stations,
      }));
      self.setShowableItems(stations);
    }).then(() => {
      onReady();
      const queryParams = bpUtils.getQueryParameters();
      if (queryParams) {
        const { stationId } = queryParams;
        if (stationId || 0) {
          this.setStationId(stationId);
        }
      }
    });
  }

  setShowableItems = (stations) => {
    const watchedStations = stations.filter(s => s.watched);
    const otherStations = this.getRemainingStations(stations, watchedStations.map(s => s.id));
    this.showableItems = watchedStations.concat(otherStations);
    this.setStationOptions();
  }

  getRemainingStations = (stations, excludeStationIds, numOfFiller = 50) => stations.filter(
    s => !excludeStationIds.includes(s.id),
  ).slice(0, numOfFiller - excludeStationIds.length) || []

  getMatchingAddress = (searchText) => {
    const { stations } = this.state;
    return stations.filter(s => `${s.address.address} ${s.address.city} ${s.address.state}`.toLowerCase().includes(searchText));
  }

  getMatchingProp = (propName, searchText) => {
    const { stations } = this.state;
    return stations.filter(s => s[propName].toLowerCase().includes(searchText));
  }

  setStationOptions = () => {
    const { watchStations } = this.props;
    const options = [];
    const watchedOptions = [];
    const items = this.showableItems;
    if (items && items.length) {
      items.forEach((item) => {
        // eslint-disable-next-line max-len
        const stationInfo = `${item.retailer_name} - #${item.retailer_reference} - ${item.address.address} ${item.address.city} ${item.address.state}`;
        const option = {
          /* As we are assigning JSX instead of String, the gb-react-component is logging following console-error
             "Only strings and numbers are supported as <option> children." */
          label: (
            <div className={styles.stationSelectorRowContainer}>
              { watchStations ? (
                <WatchStation
                  stationId={item.id}
                  isWatched={item.watched}
                  iconHeight={16}
                />
              ) : null }
              <div className={styles.stationInfoContainer}>{stationInfo}</div>
            </div>
          ),
          value: item.id,
          searchTerm: stationInfo,
        };
        if (item.watched) {
          watchedOptions.push(option);
        } else {
          options.push(option);
        }
      });
    }
    this.setState({ stationOptions: watchedOptions.concat(options) });
  }

  getStationOptions = () => {
    const { stations } = this.state;
    const options = [];
    if (stations) {
      stations.forEach((station) => {
        // eslint-disable-next-line babel/camelcase
        const { retailer_name, retailer_reference, watched } = station;
        const { address, city, state } = station.address;
        const image = `/images/app/profile-watch-${watched ? 'on' : 'off'}.png`;
        // eslint-disable-next-line babel/camelcase
        const innerHtml = `${retailer_name} - #${retailer_reference} - ${address} ${city} ${state}`;
        /* eslint-enable camelcase */
        options.push(<option value={station.id} key={station.id} img={image}><p>{innerHtml}</p></option>);
      });
    }

    return options;
  }

  discardUnusedProps = (station) => {
    station.prices.forEach((p) => {
      delete p.discount;
      delete p.legacy_fuel_product_id;
      delete p.sort_order;
      if (p.credit) {
        delete p.credit.max_valid_price;
        delete p.credit.min_valid_price;
        delete p.credit.price_id;
      }
      if (p.cash) {
        delete p.cash.max_valid_price;
        delete p.cash.min_valid_price;
        delete p.cash.price_id;
      }
    });

    return station;
  }

  setStationId = async (stationId) => {
    const { stations } = this.state;
    const { dispatchSetLoading, dispatchSetStation, onChange, doNotStoreChanges } = this.props;
    try {
      if (!stations.find(s => s.id === Number(stationId))) {
        Notification.error('Sorry, looks like you do not have access to this station');
        return;
      }
      dispatchSetLoading(true);
      this.setState({ stationId });
      if (!doNotStoreChanges) {
        bpUtils.setQueryParameter('stationId', stationId);
      }
      const res = await api.get({
        path: `/stations/${stationId}`,
        requestId: 'getStationById',
      });

      const station = this.discardUnusedProps(res);
      dispatchSetStation(station);
      if (onChange) {
        onChange(station);
      }
    } catch (err) {
      Notification.error(`Unable to fetch station ${stationId}`);
      dispatchSetStation(null);
      logError(err);
    } finally {
      dispatchSetLoading(false);
    }
  }

  handleSearch = (searchText) => {
    const { stations } = this.state;
    const searchTerm = searchText.toLowerCase();
    if (searchTerm.length) {
      const matchingRetailerRef = this.getMatchingProp('retailer_reference', searchTerm);
      const matchingRetailerName = this.getMatchingProp('retailer_name', searchTerm);
      const matchingAddress = this.getMatchingAddress(searchTerm);
      const matches = matchingRetailerRef.concat(matchingRetailerName, matchingAddress);
      const uniqueMatches = _.uniqBy(matches, 'id');
      this.setShowableItems(uniqueMatches);
    } else {
      this.setShowableItems(stations);
    }
  };

  handleStationChange = (e) => {
    const stationId = Number(e.target.value);
    const { stations } = this.state;
    this.setShowableItems(stations);
    if (stationId) {
      this.setStationId(stationId);
    }
  }

  render() {
    const { stationOptions, stationId } = this.state;
    const { className } = this.props;

    return (
      <div className={`${styles.stationSelectorContainer} ${className}`}>
        <Dropdown
          searchable
          placeholder="Search by station id, station name, or address"
          className={styles.stationSelector}
          onChange={this.handleStationChange}
          value={stationId}
          options={stationOptions}
          onSearch={this.handleSearch}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchSetStation: station => dispatch(setStation(station)),
  dispatchSetLoading: loading => dispatch(setLoading(loading)),
});

export default connect(null, mapDispatchToProps)(StationSelector);
